/** Pure helpers for VoiceVerificationPage — kept separate so they are testable. */

export type VoiceStatus = 'pending_review' | 'verified' | 'rejected';
export type PredictedGender = 'male' | 'female' | 'unknown';

/**
 * Colour for the on-device prediction tag: green when it matches the declared
 * gender, orange on a mismatch, neutral when the device could not tell (or
 * the listener declared nothing comparable).
 */
export function predictionTone(declared: string, predicted: PredictedGender): 'green' | 'orange' | 'default' {
  if (predicted === 'unknown') return 'default';
  if (declared !== 'male' && declared !== 'female') return 'default';
  return predicted === declared ? 'green' : 'orange';
}

/** Sentence language codes: lowercase ISO 639, 2–8 letters (e.g. hi, brx). */
export function isValidLanguageCode(code: string): boolean {
  return /^[a-z]{2,8}$/.test(code);
}

/** Read-aloud sentence length the API accepts (trimmed). */
export function isValidSentence(text: string): boolean {
  const n = text.trim().length;
  return n >= 10 && n <= 300;
}
